
export default {
  name: 'AppRadio',
  model: { prop: 'selectedValue', event: 'change' },
  props: {
    invalid: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    name: { type: String, default: null },
    selectedValue: { type: [String, Number, Boolean], default: null },
    value: { type: [String, Number, Boolean], default: null },
    label: { type: String, default: null },
    tooltip: { type: [String, Object], default: null },
    leadingAiIconName: {
      type: String,
      default: null,
      validator: v => ['icon-ai-gradation', 'icon-ai-solid'].includes(v)
    }
  },
  computed: {
    isChecked() {
      return this.selectedValue === this.value;
    }
  }
};
